module.exports = __webpack_public_path__ + "static/media/gainLife.eb3cbeea.svg";